module.exports = __webpack_public_path__ + "img/fb_icon-v2.fc4e76dc.svg";